import React, { useEffect, useState } from 'react';
import { Home, Info, DollarSign, TrendingUp, ShoppingCart, Bot, MessageCircle, Phone } from 'lucide-react';
export const ScrollProgress = () => {
  const [activeSection, setActiveSection] = useState('home');
  const sections = [{
    id: 'home',
    label: 'Home',
    icon: Home
  }, {
    id: 'about',
    label: 'About Us',
    icon: Info
  }, {
    id: 'core-products',
    label: 'Loan Products',
    icon: DollarSign
  }, {
    id: 'trade-finance',
    label: 'Trade Finance',
    icon: TrendingUp
  }, {
    id: 'asset-marketplace',
    label: 'Buy Now Pay Later',
    icon: ShoppingCart
  }, {
    id: 'ai-agent',
    label: 'AI Assistant',
    icon: Bot
  }, {
    id: 'contact',
    label: 'Contact',
    icon: Phone
  }];
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 100;
      for (const section of sections) {
        const element = document.getElementById(section.id);
        if (element) {
          const {
            offsetTop,
            offsetHeight
          } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section.id);
            break;
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div className="fixed left-6 top-1/2 -translate-y-1/2 z-40 hidden lg:block" data-id="element-1130">
      <nav className="bg-white rounded-2xl shadow-xl border-2 border-gray-100 p-3" aria-label="Page navigation" data-id="element-1131">
        <ul className="space-y-2" data-id="element-1132">
          {sections.map(section => {
          const Icon = section.icon;
          const isActive = activeSection === section.id;
          return <li key={section.id} data-id="element-1133">
                <button onClick={() => scrollToSection(section.id)} className={`group relative flex items-center gap-3 px-3 py-2 rounded-lg transition-all duration-300 ${isActive ? 'bg-primary-600 text-white' : 'text-gray-600 hover:bg-primary-50 hover:text-primary-600'}`} aria-label={`Navigate to ${section.label}`} aria-current={isActive ? 'true' : 'false'} data-id="element-1134">
                  <Icon size={20} data-id="element-1135" />
                  <span className={`absolute left-full ml-4 px-3 py-1 bg-gray-900 text-white text-sm rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none ${isActive ? 'opacity-0' : ''}`} data-id="element-1136">
                    {section.label}
                  </span>
                  {isActive && <div className="absolute left-0 w-1 h-full bg-white rounded-r-full -ml-3" data-id="element-1137" />}
                </button>
              </li>;
        })}
        </ul>
      </nav>
    </div>;
};